window.theme = window.theme || {};

theme.config = {
  mqlSmall: false,
  mediaQuerySmall: 'screen and (max-width: 749px)',
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
};

// Init section function when it's visible, then disable observer
theme.initWhenVisible = function(options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: `0px 0px ${threshold}px 0px`});

  observer.observe(options.element);
};

class ImageComparison extends HTMLElement {
  constructor() {
    super();

    this.active = false;
 
    this.button = this.querySelector('button');
    this.horizontal = this.dataset.layout === 'horizontal';

    
    this.init();

    theme.initWhenVisible({
      element: this.querySelector('.image-comparison__animate'),
      callback: this.animate.bind(this),
      threshold: 0
    });

  }

  

  animate() {
    this.setAttribute('animate', '');
    this.classList.add('animating');
    setTimeout(() => {
      this.classList.remove('animating');
    }, 1e3);
  }

  init() {
    if (theme.config.isTouch) {
      this.button.addEventListener('touchstart', this.startHandler.bind(this));
      document.body.addEventListener('touchend', this.endHandler.bind(this));
      document.body.addEventListener('touchmove', this.onHandler.bind(this));
    }
    else {
      this.button.addEventListener('mousedown', this.startHandler.bind(this));
      document.body.addEventListener('mouseup', this.endHandler.bind(this));
      document.body.addEventListener('mousemove', this.onHandler.bind(this));
    }
  }

  startHandler() {
    this.active = true;
    this.classList.add('scrolling');
  }

  endHandler() {
    this.active = false;
    this.classList.remove('scrolling');
  }

  onHandler(e) {
    if (!this.active) return;

    const event = (e.touches && e.touches[0]) || e;
    const x = this.horizontal
                ? event.pageX - this.offsetLeft
                : event.pageY - this.offsetTop;

    this.scrollIt(x);
    console.log('x----',x);
  }

  scrollIt(x) {
    const distance = this.horizontal ? this.clientWidth : this.clientHeight;

    const max = distance - 20;
    const min = 20;
    const mouseX = Math.max(min, (Math.min(x, max)));
    const mousePercent = (mouseX * 100) / distance;
    this.style.setProperty('--percent', mousePercent + '%');
  }
}
customElements.define('image-comparison', ImageComparison);


// 用户自定义js公共库
function isMobile() {
  return (/Android|iPhone|iPad|iPod|BlackBerry/i).test(navigator.userAgent || navigator.vendor || window.opera);
}

// seo 优化
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

/**
  * 防抖
  */
function debounce(func, delay) {
  let timer;

  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

/**
 * GTM 增加GA事件
 * @param {*} category 
 * @param {*} operating 
 * @param {*} label 
 */
function commonGtmEvent(category, operating, label) {
  // if(isMobile()){
  //   category = `M${category}`
  // }
  // dataLayer.push({ event: 'common', category, operating, label });
  gtag('event', category, {
    operating: operating,
    label: label
  });
}

/**
 * 获取cookie
 * @param {名称} name 
 * @returns 
 */
function getCookie(name) {
  const cookieName = name + '=';
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return '';
}

/**
 * 设置cookie
 * @param {string} cookieName - cookie的名称
 * @param {string} cookieValue - cookie的值
 * @param {number} daysToExpire - cookie的过期天数，默认为0，表示永不过期
 */
function setCookie(cookieName, cookieValue, daysToExpire, endOfDay = false) {
  var expires = "";
  if (daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
    if (endOfDay) {
      date.setHours(00, 00, 00, 000); // 设置为那天的第一秒
    }
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = cookieName + "=" + cookieValue + expires + "; path=/";
}

/**
 * 初始化事件
 */
function init(){
  // seo 解决图片
  // 获取所有 <video> 标签中的 <img> 标签
  const videoImages = document.querySelectorAll('video img');
  // 遍历所有的 <img> 标签，并设置 alt 属性
  videoImages.forEach((img) => {
    img.setAttribute('alt', 'video image');
    img.setAttribute('loading', 'lazy');
  });
  // 处理全局折扣码
  let gDiscount = getUrlParameter("discount");
  if (gDiscount) {
    setCookie('discount_code', gDiscount, 1);
    setTimeout(function () {
      let cartCodeArr = window.discountOnCartProApp.codes;
      if (cartCodeArr.length < 1) {
        // 应用优惠劵
        window.discountOnCartProApp.applyCode(gDiscount);
      }
    }, 6000)
  }
}

function initGA() {
  //  抽奖
  $(document).on("click", ".lucky-coupon-popup .launcher", function () {
    // 输入邮箱才触发
    if ($('.lucky-coupon-popup .wheel-form .email').eq(0).val()){
      commonGtmEvent('luckydraw', 'click', 'pop');
    }
  });

  // 移除优惠券 刷新购物车
  document.body.addEventListener('docapp-discount-code-remove', (e) => {
    console.log('Code is being removed', e);
    setTimeout(function () {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: false,
        })
      );
    }, 4400);
  });

  document.body.addEventListener('docapp-discount-code-submit', (e) => { 
    let code = $('.docapp-coupon-input--input').val()
    if (code){
      window.discountOnCartProApp.removeCode(window.discountOnCartProApp.codes[0]);
    }
  });

}


document.addEventListener("DOMContentLoaded", function() {
  init();
  initGA();
})


/**
 * 从URL中获取指定参数的值
 * @param {string} paramName 需要获取的参数名
 * @return {string|null} 如果找到指定参数，则返回其值；否则，返回null
 */
function getUrlParameter(paramName) {
  // 创建一个URLSearchParams对象，用于解析URL中的查询参数
  const params = new URLSearchParams(window.location.search);
  // 使用指定的参数名获取参数值并返回
  return params.get(paramName);
}

/**
 * 验证邮箱格式是否正确
 * @param {string} email - 待验证的邮箱地址
 * @returns {boolean} - 返回true表示邮箱格式正确，返回false表示邮箱格式错误
 */
function validateEmail(email) {
  // 邮箱正则表达式
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // 使用正则表达式测试邮箱格式是否正确
  return emailRegex.test(email);
}


/**
 * 优惠券使用
 * @param {*} callback 
 */
function checkObject(code) {
  let attempts = 0;
  const maxAttempts = 10;

  function attemptCheck() {
    if (window.discountOnCartProApp) {
      // 对象存在，执行回调函数
      window.discountOnCartProApp.applyCode(code);
    } else if (attempts < maxAttempts) {
      // 对象不存在，1秒后再次检查
      attempts++;
      setTimeout(attemptCheck, 1000);
    } else {
      // 超过最大尝试次数
      console.log("Reached maximum number of attempts. Object not found.");
    }
  }
  attemptCheck();
}



function autoDiscountCode(code) {
  setTimeout(function () {
    checkObject(code);
  }, 2000)
}

window.ULIKE_MESSAGES = window.ULIKE_MESSAGES || {
  default_error: 'Abonnement fehlgeschlagen. Bitte versuchen Sie es erneut.',
  email_empty: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
  email_invalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  consent_required: 'Bitte stimmen Sie den Nutzungsbedingungen und der Datenschutzrichtlinie zu.',
  user_subscribe_email_repeat: 'Diese E-Mail-Adresse ist bereits abonniert. Bitte verwenden Sie eine andere E-Mail-Adresse.',
  user_subscribe_phone_repeat: 'Diese Telefonnummer ist bereits abonniert. Bitte verwenden Sie eine andere Telefonnummer.'
};

function subscriptionApiNew(email, tag,type) {
  let data = {
    userEmail: email,
    userPhone: '',
    scene: type || 'USER_SUBSCRIBE',
    tags: [tag],
  };
  return sendUlikeApi('/user/userSubscribe', data);
}


function sendUlikeApi(url, data) {
  data.siteCode = 'DE'; 
  var _url = 'https://api.ulike.com/eu' + url;
  data.language = window.Shopify.locale;

  data.requestId = generateGUID();
  // Set up the AJAX settings
  var settings = {
    url: _url,
    method: 'POST', // POST is used as the request method
    headers: {
      'Content-Type': 'application/json', // Request payload is in JSON format
    },
    data: JSON.stringify(data), // Convert data object to JSON string
    xhrFields: {
      withCredentials: true, // Allow cookies and credentials to be sent
    },
  };

  // Return a new Promise
  return new Promise((resolve, reject) => {
    $.ajax(settings)
      .done(function (response) {
        resolve(response); // Resolve the promise with the response
      })
      .fail(function (error) {
        console.error('Error during API call:', error); // Log the error
        reject(error); // Reject the promise with the error
      });
  });
}

// 复制code
function copyTextFallback(text) {
  if (navigator.clipboard) {
    // 确保运行在安全上下文（如 HTTPS）下才能使用 Clipboard API
    navigator.clipboard.writeText(text);
  } else {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed'; // 使文本框不可见
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('error:', err);
    }
    document.body.removeChild(textArea); // 删除临时文本框
  }
}


function generateGUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return (
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    s4()
  );
}


function formatMoney(cents, format = '') {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split('.'),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  let value = '';
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_no_decimals_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}



class LuxuryVideoModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `
      <div class="luxury-video-overlay">
        <div class="luxury-video-bg"></div>
        <div class="luxury-video-content">
          <button class="luxury-video-close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div class="luxury-video-wrapper">
            <video controls playsinline></video>
          </div>
        </div>
      </div>
    `;

    this.overlay = this.querySelector('.luxury-video-overlay');
    this.bg = this.querySelector('.luxury-video-bg');
    this.closeBtn = this.querySelector('.luxury-video-close');
    this.videoEl = this.querySelector('video');

    this.close = this.close.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.closeBtn.addEventListener('click', this.close);
    this.bg.addEventListener('click', this.close);
  }

  disconnectedCallback() {
    this.closeBtn.removeEventListener('click', this.close);
    this.bg.removeEventListener('click', this.close);
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown(e) {
    if (e.key === "Escape") this.close();
  }

  open(videoUrl) {
    if (!videoUrl) return;

    this.videoEl.src = videoUrl;
    document.addEventListener('keydown', this.handleKeyDown);
document.body.classList.add('no-scroll');
    requestAnimationFrame(() => {
      this.overlay.classList.add('is-active');
    });
    
    this.videoEl.play();
  }

  close() {
    document.removeEventListener('keydown', this.handleKeyDown);
    
    this.overlay.classList.remove('is-active');
document.body.classList.remove('no-scroll');
    setTimeout(() => {
      this.videoEl.pause();
      this.videoEl.currentTime = 0;
      this.videoEl.src = '';
    }, 400); 
  }
}

customElements.define('luxury-video-modal', LuxuryVideoModal);



class CustomSwiperNew6 extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    const swiperContainer = this.querySelector('.swiper-container');
    if (!swiperContainer) {
      console.error('Swiper container not found');
      return;
    }

    // **设备判断：是否禁用 Swiper**
    const disableOn = this.getAttribute('disable-on'); // 'mobile' 或 'desktop'
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    if ((disableOn === 'mobile' && isMobile) || (disableOn === 'desktop' && !isMobile)) {
      console.log(`Swiper disabled on ${disableOn}`);
      return;
    }

    // **Swiper 组件参数**
    const slidesPerView = parseFloat(this.getAttribute('slides-per-view')) || 1.3;
    const spaceBetween = parseFloat(this.getAttribute('space-between')) || 10;
    const loop = this.getAttribute('loop') !== 'false'; // 默认为 true
    const centeredSlides = this.getAttribute('centered-slides') !== 'false'; // 默认为 true
    const paginationEnabled = this.getAttribute('pagination') === 'true'; // 是否启用分页
    const navigationEnabled = this.getAttribute('navigation') === 'true'; // 是否启用导航按钮
    let breakpoints = {};
    try {
      breakpoints = JSON.parse(this.getAttribute('breakpoints') || '{}');
    } catch (error) {
      console.error('Invalid breakpoints format. Expected JSON.');
    }

    const prevButton = navigationEnabled ? this.querySelector('.swiper-prev') : null;
    const nextButton = navigationEnabled ? this.querySelector('.swiper-next') : null;
    const paginationEl = paginationEnabled ? { el: this.querySelector('.swiper-pagination'), clickable: true } : false;

    this.swiper = new Swiper(swiperContainer, {
      slidesPerView,
      spaceBetween,
      loop,
      centeredSlides,
      navigation: navigationEnabled ? { prevEl: prevButton, nextEl: nextButton } : false,
      pagination: paginationEl,
      breakpoints
    });
  }
}

window.customElements.define('custom-swiper-new6', CustomSwiperNew6);